<template>
    <div class="myDonation">
        <van-nav-bar
                title="直接捐赠"
                left-text=""
                left-arrow
                @click-left="onClickLeft"
        />
        <div class="donation_list">
            <div class="list_content">
                <div class="content" v-if="donationList.length">
                    <div class="don_item" v-for="(item,index) in donationList" :key="index">
                        <div class="item_donor">
                            <span class="item_label">捐款人姓名：</span>
                            <span>{{item.donorName}}</span>
                        </div>
                        <div class="item_meta">
                            <div class="item_date">
                                <span class="item_label">捐款时间：</span>
                                <span>{{item.successTime}}</span>
                            </div>
                            <div class="item_money">
                                <span class="item_label">捐款金额：</span>
                                <strong><span class="currency">¥</span>{{item.amount}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="donation_empty" v-else>
                    <img src="@/assets/donation_empty.png" alt="">
                </div>
            </div>
        </div>
      <div class="school_logo"><img src="@/assets/form_logo.png" alt=""></div>
    </div>
</template>

<script>
import {donationInfo} from '../../utils/ajaxInterface'
import moment from 'moment'
export default {
  name: 'myDonation',
  data () {
    return {
      donationList: []
    }
  },
  created () {
    this.getDonation()
  },
  methods: {
    edit () {
      this.$router.push('/personalEdit')
    },
    onClickLeft () {
      this.$router.push('/personalCenter')
    },
    getDonation () {
      donationInfo().then(res => {
        let newList = []
        if (res.records.length) {
          res.records.forEach(item => {
            newList.push({
              amount: item.amount,
              donorName: item.anonymous ? '匿名捐款' : (item.certTitle || '匿名捐款'),
              successTime: moment(item.successTime).format('YYYY年M月D日 HH:mm')
            })
          })
        }
        this.donationList = newList
      }).catch(e => {
        this.$toast.fail(e)
      })
    }
  }
}
</script>

<style scoped lang="less">
    .myDonation {
        min-height: 100vh;
        background-color: #f5f7f9;
        .donation_list{
            width: 100%;
            margin-top: 10px;
            padding: 12px 16px 120px;
            box-sizing: border-box;
            min-height: calc(100vh - 56px);
            .list_title{
                padding: 0 0 12px;
                box-sizing: border-box;
                font-weight: 500;
                font-size: 16px;
                color: #111111;
            }
            .list_content{
                box-sizing: border-box;
                .content{
                    display: flex;
                    flex-direction: column;
                    .don_item{
                        width: 100%;
                        min-height: 82px;
                        padding: 14px 12px;
                        box-sizing: border-box;
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 20px;
                        color: #666666;
                        background-color: #ffffff;
                        border: 1px solid #eeeeee;
                        border-radius: 8px;
                        box-shadow: 0 2px 8px rgba(8, 34, 66, 0.06);
                        .item_donor{
                            padding-bottom: 10px;
                            border-bottom: 1px solid #eeeeee;
                            color: #555555;
                        }
                        .item_meta{
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-end;
                            padding-top: 10px;
                        }
                        .item_label{
                            color: #929292;
                        }
                        .item_money{
                            flex-shrink: 0;
                            white-space: nowrap;
                            strong{
                                font-size: 19px;
                                font-weight: 600;
                                color: #0067DD;
                            }
                            .currency{
                                margin-right: 2px;
                                font-size: 14px;
                            }
                        }
                        .item_date{
                            min-width: 0;
                            margin-right: 12px;
                            color: #929292;
                        }
                    }
                    .don_item + .don_item{
                        margin-top: 10px;
                    }
                }
                .donation_empty{
                    padding-top: 30px;
                    text-align: center;
                    img{
                        width: 214px;
                        height: 214px;
                    }
                }
            }
        }
      @media (max-width: 350px) {
        .donation_list .list_content .content .don_item .item_meta{
          align-items: flex-start;
          flex-direction: column;
          .item_date{
            margin-right: 0;
            margin-bottom: 6px;
          }
        }
      }
      .school_logo{
        position: fixed;
        left: 0;
        right: 0;
        bottom: 40px;
        width: 100%;
        height: 33px;
        text-align: center;
        img{
          width: 234px;
          height: 100%;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/donation/myDonation.vue